import React, { useState } from "react";

import { Col, Container, Dropdown, Form, Row } from "react-bootstrap";

import classNames from "classnames";

import { FilterBy, PaymentStatuses, ResaleStatuses } from "@api/graphql";
import { useIsAuthUserAllowed } from "@components/permission_control/ProtectedComponent";
import { ExternalRoles } from "@roles";
import { filterDropdownTitle, getDisplayValueFromDBValue, useWatch } from "@util/index";

import styles from "./TableFilter.module.scss";

export interface TableFilterInput {
  option: ResaleStatuses | PaymentStatuses;
  defaultValue: boolean;
}

export interface TableFilterInputProps {
  field: string;
  title: string;
  inputs: TableFilterInput[];
  setFilter: React.Dispatch<React.SetStateAction<FilterBy | undefined>>;
  showInvoiceRequestSentFilter: boolean;
}

interface TableFilterItem {
  key: ResaleStatuses | PaymentStatuses;
  label: string;
  value: ResaleStatuses | PaymentStatuses;
  checked: boolean;
}

export const TableFilter = ({
  field,
  title,
  inputs,
  setFilter,
  showInvoiceRequestSentFilter,
}: TableFilterInputProps) => {
  const isExternalUser = useIsAuthUserAllowed(ExternalRoles);
  const options = inputs.map((input) => ({
    key: input.option,
    label: getDisplayValueFromDBValue(input.option, isExternalUser, showInvoiceRequestSentFilter),
    value: input.option,
    checked: input.defaultValue,
  }));

  const [filterState, setFilterState] = useState<TableFilterItem[]>(options);

  const handleCheck = (key: string) => {
    setFilterState(filterState.map((item) => (key === item.key ? { ...item, checked: !item.checked } : item)));
  };

  const allowedItems = filterState.filter((item) => item.checked).map((item) => item.value);

  const filterExpression: FilterBy | undefined =
    allowedItems.length > 0
      ? {
          field: field,
          in: allowedItems,
        }
      : undefined;

  useWatch(filterState, () => {
    setFilter(filterExpression);
  });

  return (
    <Container fluid className="d-inline">
      <Row>
        <Col>
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              className={classNames(styles[allowedItems.length === 0 ? "dropdown-toggle" : "dropdown-toggle-active"])}
            >
              {filterDropdownTitle(title, allowedItems, isExternalUser)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {filterState.map((item) => (
                <Form.Check
                  key={item.key}
                  label={item.label}
                  id={`filter-${item.key}`}
                  value={item.value}
                  checked={item.checked}
                  className={classNames(styles["dropdown-item"])}
                  onChange={() => {
                    handleCheck(item.key);
                  }}
                ></Form.Check>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </Container>
  );
};
